import { Component, Inject } from "@angular/core";
import { NgFor, NgIf } from "@angular/common";
import {
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { ScoreLocalService } from "../../pages/score/score.service";
import { CategoryDto, TagDto } from "../../../swagger/api.client.generated"; // Adjust the path as needed
import { MatChipsModule } from "@angular/material/chips";
import { CategoriesAndTagsDisplayComponent } from "../categories-and-tags-display/categories-and-tags-display.component";
import { ErrorDisplayComponent } from "../error-display/error-display.component";
import { DialogDefaultModalComponent } from "../dialog-default-modal/dialog-default-modal.component";
import { DialogCloseResponse } from "../dialog-default-modal/dialog-default-modal.models";
@Component({
  selector: "app-dialog-add-tag",
  templateUrl: "./dialog-add-tag.component.html",
  styleUrls: ["./dialog-add-tag.component.scss"],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    NgIf,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    ReactiveFormsModule,
    MatChipsModule,
    CategoriesAndTagsDisplayComponent,
    ErrorDisplayComponent,
    DialogDefaultModalComponent,
  ],
})
export class DialogAddTagComponent {
  editTagForm: FormGroup;
  category: CategoryDto;
  categories: CategoryDto[] = [];
  formErrors = {
    name: "",
    category: "",
  };

  constructor(
    public dialogRef: MatDialogRef<DialogAddTagComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TagDto,
    private scoreLocalService: ScoreLocalService
  ) {
    this.scoreLocalService.categoriesChanged.subscribe((a) => {
      this.categories = a;
    });

    this.editTagForm = new FormGroup({
      name: new FormControl("", [Validators.required]),
    });
  }

  save(): void {
    if (!this.validateForm()) {
      return;
    }

    const newTag: TagDto = new TagDto({
      id: 0,
      name: this.editTagForm.get("name").value,
      categoryId: this.category.id,
    });

    this.dialogRef.close(newTag);
  }

  toggleCategorySelection(category: CategoryDto) {
    if (this.isSelectedCategory(category)) {
      this.category = null;
    } else {
      this.category = category;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  isSelectedCategory(category: CategoryDto): boolean {
    return this.category && this.category.id === category.id;
  }

  private validateForm(): boolean {
    this.formErrors = {
      name: "",
      category: "",
    };

    let isValid = true;

    if (!this.editTagForm.get("name").value?.trim()) {
      this.formErrors.name = "Name is required";
      isValid = false;
    }

    if (!this.category) {
      this.formErrors.category = "Category is required";
      isValid = false;
    }

    if (
      this.category?.tags.some(
        (tag) =>
          tag.name.toLowerCase() ===
          this.editTagForm.get("name").value.toLowerCase()
      )
    ) {
      this.formErrors.name =
        "A TAG WITH THIS NAME ALREADY EXISTS IN THIS CATEGORY";
      isValid = false;
    }

    return isValid;
  }

  handleAction(event: DialogCloseResponse) {
    if (event.action === "confirm") {
      this.save();
    } else {
      this.close();
    }
  }
}
